import { ChildrenItem } from "../base"
import { Accordion } from "./model"
import { home, appHome } from "./diffrence_options"
import cover from "../../assets/images/default_image_home.png"

let icon = ""
export let accordion_children = []
export let app_accordion_children = []
for (let i = 0; i < home.length; i++) {
  accordion_children.push(new ChildrenItem("样式" + (i + 1), icon, "emptyLayoutComponent", new Accordion(home[i]), cover))
}
for (let i = 0; i < appHome.length; i++) {
  app_accordion_children.push(
    new ChildrenItem("样式" + (i + 1), icon, "emptyLayoutComponent", new Accordion(appHome[i]), cover)
  )
}
